export enum RoleProfileStandardProperties{
    setName = 'Vmware Management Profile Set',
    groupname = 'Vmware Management Profile Group',
    roleName = 'Vmware Management Profile Name'
}